function getEvent(info, external) {
    const streetCityName =
        info.address || [info.streetAddress, info.cityAddress].join();

    let eventName = streetCityName;
    let chime3dTour = info.chime3DTourFlag || '';
    if (chime3dTour == 'Yes') {
        eventName = '3D Tour Available ' + streetCityName;
    }

    if (info.openHouseFlag == 1) {
        const openHouseDesc =
            info.openHouseDesc || info.openHouseSchedules || '';
        eventName = 'Open House ' + openHouseDesc + streetCityName;
    }

    const price = info.soldPrice || info.price || 0;
    const url = external.url;

    const priceCurrency = external.currencyAbbr || 'USD';
    const isSold = Boolean(info.soldDateStr);
    const availability = isSold
        ? 'http://schema.org/SoldOut'
        : 'http://schema.org/InStock';
    const image =
        info.previewPicture ||
        (info.listingPictures && info.listingPictures.split('|')[0]);

    let startTime =
        info.openHouseSchedulesStart &&
        info.openHouseSchedulesStart.replace(/\-/g, '/');
    let endTime =
        info.openHouseSchedulesEnd &&
        info.openHouseSchedulesEnd.replace(/\-/g, '/');

    startTime = startTime || new Date().toString();
    endTime = endTime || new Date().toString();

    return {
        '@type': 'Event',
        '@context': 'https://schema.org',
        name: eventName,
        startDate: new Date(startTime),
        endDate: new Date(endTime),
        url,
        description:
            info.detailsDescribe ||
            `${streetCityName} is ${info.listingStatus} in ${price} ${priceCurrency}`,
        image,
        eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
        eventStatus: 'https://schema.org/EventScheduled',
        offers: {
            '@type': 'Offer',
            price,
            priceCurrency,
            url,
            availability,
            validFrom: startTime
        },
        organizer: {
            '@type': 'Organization',
            name: info.agentOrganizationName,
            url
        },
        location: {
            '@type': 'VirtualLocation',
            url
        },
        performer: {
            '@type': 'Person',
            name: info.agentName
        }
    };
}

function getSingleFamilyResidence(info, url, country) {
    const streetCityName = [info.streetAddress, info.cityAddress].join();
    return {
        '@type': 'SingleFamilyResidence',
        name: streetCityName,
        url,
        address: {
            '@type': 'PostalAddress',
            streetAddress: info.streetAddress,
            addressLocality: info.city,
            addressRegion: info.state,
            postalCode: info.zipCode,
            addressCountry: country
        },
        geo: {
            '@type': 'GeoCoordinates',
            latitude: info.latitude,
            longitude: info.longitude
        },
        numberOfRooms: info.bedrooms
    };
}

/**
 *
 * @param {listingDetail} info
 * @param {option:{country}} param1
 * @returns schema.org info used by search engine
 */
function getListingDetailSchemaInfo(info, external) {
    let { location, country } = external;
    const url = location.origin + location.pathname;
    external.url = url;

    let chime3DTour = info.chime3DTourFlag || '';
    let schemaInfo = {};

    if (chime3DTour == 'Yes' || info.openHouseFlag == 1) {
        schemaInfo = Object.assign(
            {
                ...getEvent(info, external),
                ...getSingleFamilyResidence(info, url, country)
            },
            { '@type': ['Event', 'SingleFamilyResidence'] }
        );
    } else {
        schemaInfo = Object.assign(
            {
                ...getSingleFamilyResidence(info, url, country)
            },
            { '@type': 'SingleFamilyResidence' }
        );
    }

    return [
        {
            '@type': 'SingleFamilyResidence',
            address: {
                '@type': 'PostalAddress',
                streetAddress: info.streetAddress
            }
        },
        schemaInfo
    ];
}

function getHouseSchemaInfo(info, external) {
    let { country, url, location } = external;
    url = `${location.origin}${url}`;
    external.url = url;

    let chime3DTour = info.chime3DTourFlag || '';
    let schemaInfo = [];
    if (chime3DTour == 'Yes' || info.openHouseFlag == 1) {
        schemaInfo = [
            getSingleFamilyResidence(info, url, country),
            getEvent(info, external)
        ];
    } else {
        schemaInfo = [getSingleFamilyResidence(info, url, country)];
    }

    return schemaInfo;
}

function getVideoSchemeInfo({ embedUrl, thumbnailUrl, duration }) {
    var res = {
        embedUrl,
        thumbnailUrl:
            thumbnailUrl ||
            'https://static.chimeroi.com/home_pictures/Chime-Logo.svg',
        name: 'chime video',
        description: 'chime video',
        uploadDate: '2023-03-29 13:08:35',
        expires: '2023-04-03 23:59:59',
        '@type': 'VideoObject'
    };
    if (duration) {
        res.duration = `PT${duration}S`;
    }
    return res;
}

export { getListingDetailSchemaInfo, getHouseSchemaInfo, getVideoSchemeInfo };
